<template>
  <svg width="40" height="40" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g
      transform="translate(8 9)"
      :fill="menuActive ? activeColor : color"
      stroke="none"
      stroke-width="1"
      fill-rule="evenodd"
    >
      <rect x="0" y="0" width="23" height="2.9" rx="1.45" />
      <rect x="0" y="9" width="23" height="2.9" rx="1.45" />
      <rect x="0" y="18" width="15" height="2.9" rx="1.45" />
    </g>
  </svg>
</template>

<script lang="ts">
// #9FAAD2
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class MenuIcon extends Vue {
  @Prop({ type: String, default: 'var(--motif-500)' }) activeColor: boolean;
  @Prop({ type: String, default: 'var(--motif-100)' }) color: boolean;
  get menuActive() {
    return this.$store.state.common.menuActive;
  }
}
</script>
